import CustomSelect from 'components/ui/Editor/CustomSelect';
import TextInput from 'components/ui/TextInput';
import { FormikProps } from 'formik';
import { FC, useEffect } from 'react';
import { IMcqQuestionFormInput } from './schema';
import FormikValidationError from 'components/ui/FormikErrors';

interface IMcqQuestionFormProps {
  formik: FormikProps<IMcqQuestionFormInput>;
  selectedData?: IMcqQuestionFormInput | null; // For edit mode
  evId: number;
}

const AddMcqQuestionForm: FC<IMcqQuestionFormProps> = ({ formik, selectedData, evId }) => {
  useEffect(() => {
    if (selectedData) {
      formik.setValues(selectedData);
    } else {
      formik.resetForm();
      formik.setFieldValue('evaluation_id', Number(evId));
    }
  }, [selectedData, evId]);

  const correctOptionOptions = [
    { value: 'A', label: 'Option A' },
    { value: 'B', label: 'Option B' },
    { value: 'C', label: 'Option C' },
    { value: 'D', label: 'Option D' }
  ];

  console.log(formik.errors);

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="row">
        <TextInput
          label="Question Title"
          name="question_title"
          type="text"
          placeholder="Enter the question"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.question_title}
          formik={formik}
        />

        <TextInput
          label="Option A"
          name="option_a"
          type="text"
          placeholder="Enter option A"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.option_a}
          formik={formik}
        />

        <TextInput
          label="Option B"
          name="option_b"
          type="text"
          placeholder="Enter option B"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.option_b}
          formik={formik}
        />

        <TextInput
          label="Option C"
          name="option_c"
          type="text"
          placeholder="Enter option C"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.option_c}
          formik={formik}
        />

        <TextInput
          label="Option D"
          name="option_d"
          type="text"
          placeholder="Enter option D"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.option_d}
          formik={formik}
        />

        <CustomSelect
          options={correctOptionOptions}
          placeholder={'Select Details'}
          value={formik.values.correct_option}
          onChange={(value: any) => {
            formik.setFieldValue('correct_option', value);
          }}
          label={'Select correct option'}
        />
        <FormikValidationError
          name="correct_option"
          errors={formik.errors}
          touched={formik.touched}
        />
        {/* <div className="">
          <label className="form-label">Correct Option</label>
          <Select
            options={correctOptionOptions}
            value={correctOptionOptions.find((opt) => opt.value === formik.values.correct_option)}
            onChange={(option) => formik.setFieldValue('correct_option', option?.value || 'a')}
            onBlur={() => formik.setFieldTouched('correct_option', true)}
            placeholder="Select correct option"
            className="react-select-container"
            classNamePrefix="react-select"
          />
          <FormikValidationError
            name="correct_option"
            errors={formik.errors}
            touched={formik.touched}
          />
        </div> */}

        {/* Marks */}
        <TextInput
          label="Marks"
          name="marks"
          type="number"
          placeholder="e.g. 5"
          min="0"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.marks}
          formik={formik}
        />

        {/* Display Order */}
        <div className="col-lg-6 mb-3">
          <TextInput
            label="Display Order"
            name="display_order"
            type="number"
            placeholder="e.g. 1"
            min="1"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.display_order}
            formik={formik}
          />
        </div>

        {/* Hidden evaluation_id (if needed for submission) */}
        <input type="hidden" name="evaluation_id" value={formik.values.evaluation_id} />
      </div>
    </form>
  );
};

export default AddMcqQuestionForm;
